import React from 'react';
import { beautifyNumber } from '../../../../Utils/FormatNumber';
import styles from '../ReportModalXtram.module.scss';

const AccumulatedAdvancePanel = ({ t, accumulatedAdvance }) => {
    if (!accumulatedAdvance) return null;

    const items = [
        { label: t("המחזור העסקי"), value: accumulatedAdvance.incomesNoVats },
        { label: t("IncomeTaxAdvancesDifference"), value: accumulatedAdvance.total },
        { label: t("AcceptedWithholdingTax"), value: accumulatedAdvance.acceptedWithholdingTax, negative: true },
        { label: t("TotalDifference"), value: accumulatedAdvance.incomeTaxAdvances, isTotal: true },
    ];

    return (
        <div className={styles.panel}>
            <div className={styles.panelHeader}>{t("AccumulatedDifferenceInAdvances")}</div>
            <table className={styles.kvTable}>
                <tbody>
                    {items.map((item) => (
                        <tr key={item.label} className={item.isTotal ? styles.kvTotal : undefined}>
                            <th scope="row">{item.label}</th>
                            <td className={item.value >= 0 && !item.negative ? styles.positive : styles.negative}>
                                {item.negative ? `(${beautifyNumber(item.value)})` : beautifyNumber(item.value)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AccumulatedAdvancePanel;
